<!-- MOBILE DROPDOWN NAV -->
<script lang="ts">
	import { onMount, onDestroy } from 'svelte';
	import { profileStore, user, avatarUrlStore, profileLoading } from '$lib/user';
	import { createStore } from '$lib/chat/Notification.store';
	import { supabaseClient } from '$lib/supabase';
	import NavbarToggle from './NavbarToggle.svelte';
	import { goto } from '$app/navigation';
	import { getSystemname } from '$lib/locations';
	import placenamesStore from '$lib/locations/placenames.store';
	import { writable } from 'svelte/store';

	import avatars from '$lib/components/common/AvatarLibrary.json';
	import { paraLogin, paraLogout } from '$lib/user/para/functions';
	import type { ExtendedNotification } from '$lib/chat/Notification.store';

	let isMenuOpen = false;
	// let moreToggle = false;
	export const topLink =
		'm-auto text-lg 2xl:text-xl font-semibold font-quicksand text-center cursor-pointer mx-4 no-underline hover:no-underline ';
	export const buttonBase = 'button shadow-lg rounded-full py-2 px-4 ';
	export const findButton =
		buttonBase + 'bg-primary text-gray-100 border-2 border-solid border-bloomBlueNormal';
	export const navMenuClass =
		'text-gray-100 text-left block rounded-md text-base font-semibold uppercase cursor-pointer pl-5 font-exo-2';
	export const navMenuClassMobile =
		'text-left lg:text-left block rounded-md text-base text-cosmicPurple100 font-semibold cursor-pointer pl-5 font-exo-2 py-2';
	let profileToggle = false;
	let navToggle = false;
	let notificationsStore: ReturnType<typeof createStore>;
	let unreadCount = writable(0);
	let notifications: ExtendedNotification[] = [];
	// let moreToggle = false;
	let avatarUrl: string;
	let hrefB = '/member/nobloomyet';

	function toggleMenu() {
		isMenuOpen = !isMenuOpen;
		console.log(isMenuOpen);
	}

	// const toggleMore = () => {
	// 	moreToggle = !moreToggle;
	// };

	const toggleNav = () => {
		isMenuOpen = false;
		profileToggle = false;
		navToggle = !navToggle;
	};

	const getLocalBloomRoute = async (localbloom: string) => {
		// console.log('localbloom', localbloom);
		const route = await getSystemname(localbloom);
		toggleNav();
		// console.log('route', route);
		const href = `/${route}`;
		goto(href);
	};

	// Subscribe to avatarUrlStore
	const unsubscribe = avatarUrlStore.subscribe((url) => {
		avatarUrl = url ?? getRandomAvatar(); // Ensure avatarUrl is always a string
	});

	const getRandomAvatar = () => {
		return avatars[Math.floor(Math.random() * avatars.length)];
	};

	async function handleRoute() {
		const localbloom = $profileStore.localbloom;
		if (localbloom && $placenamesStore.includes(localbloom)) {
			await getLocalBloomRoute(localbloom);
		} else {
			// Handle case where localbloom doesn't exist
			toggleNav();
			goto(hrefB);
		}
	}

	const toggleProfile = async () => {
		navToggle = false;
		profileToggle = !profileToggle;
		if (profileToggle) {
			try {
				// const newNotifications = await getUnreadUserNotifs();
				// console.log('newNotifications', newNotifications);
			} catch (error) {
				console.error('Error fetching unread notifications:', error);
				// Handle the error appropriately
			}
		}
		// console.log('profileToggle', profileToggle);
	};

	const onSignout = async () => {
		profileToggle = false;
		await paraLogout();
	};

	onMount(() => {
		if (!$profileStore.username) {
			// Handle the case where username is not set
			return;
		}
		avatarUrl = $profileStore.avatar_url || getRandomAvatar();
		notificationsStore = createStore($profileStore.username);
		const unsubscribeNotifications = notificationsStore.subscribe((value) => {
			notifications = value;
			unreadCount.set(notifications.filter((notification) => !notification.read).length);
		});

		const memberChat = supabaseClient
			.channel('schema-db-changes')
			.on(
				'postgres_changes',
				{
					event: 'INSERT',
					schema: 'public',
					table: 'notifications'
				},
				(payload) => {
					if (
						payload.new.replied_to_username === $profileStore.username ||
						payload.new.mentioned.includes($profileStore.username)
					) {
						notificationsStore.refresh();
					}
				}
			)
			.subscribe();

		// Cleanup subscription on component unmount
		return () => {
			unsubscribeNotifications();
			memberChat.unsubscribe();
		};
	});

	onDestroy(() => {
		unsubscribe();
	});
</script>

<div
	class={`absolute inset-y-0 left-4 sm:left-8 items-center xl:hidden ${$user ? 'lg:hidden' : 'lg:inline'}`}
>
	<NavbarToggle {toggleMenu} {isMenuOpen} />
</div>

{#if isMenuOpen}
	<div class="xl:hidden" id="mobile-menu">
		<div class="pb-3 space-y-1 bg-cosmicPurple800 top-[72px] left-0 absolute w-full text-left">
			<ul class="pb-4 text-cosmicPurple100 text-left font-semibold font-exo w-80">
				<div class="px-4">
					<div class="flex flex-row -ml-1">
						{#if !$user}
							<a
								href={'/communityposts'}
								data-sveltekit-preload-data="hover"
								on:click={toggleNav}
								class={navMenuClassMobile}
								><button
									class="border bg-cosmicPurple100 border-cosmicMagenta100 text-cosmicPurple800 font-black"
									>Media</button
								></a
							>
						{:else}
							<a
								href={'/vision'}
								data-sveltekit-preload-data="hover"
								on:click={toggleNav}
								class={navMenuClassMobile}
								><button
									class="border bg-cosmicPurple100 border-cosmicMagenta100 text-cosmicPurple800 font-black"
									>About</button
								></a
							>
						{/if}
						<a
							href={'/engage/localBlooms'}
							data-sveltekit-preload-data="hover"
							on:click={toggleNav}
							class={navMenuClassMobile}
							><button
								class="border
									 bg-cosmicPurple100 border-cosmicMagenta100 text-cosmicPurple800 font-black">Local Hubs</button
							></a
						>
					</div>
					{#if !$user}
						<div>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/vision">About</a>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/team">Team</a>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/engage/communityCalls"
								>Events</a
							>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/marketplace">Marketplace</a>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/bloomers-without-borders"
								>Volunteer</a
							>
							<a class={navMenuClassMobile} on:click={toggleNav} href="/donate">Donate</a>
						</div>
					{/if}
				</div>
				<div>
					{#if !$user}
						<a
							href={'/auth'}
							data-sveltekit-preload-data="hover"
							on:click={toggleNav}
							class={navMenuClassMobile}
							><button
								class="bg-gradientBlueMid border-2 border-gradientGreen text-black font-bold hover:scale-105 text-center text-xs"
								>Login/Join</button
							></a
						>
					{/if}
				</div>
				{#if $user}
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg class="mx-auto" xmlns="http://www.w3.org/2000/svg" width="29.41" height="22.46"
							><path
								d="M31.41 0C27.2 3.5 23.36 3.43 18.7 6.03s-4.87 6.54-4.87 6.54c-.15-1.11.13-3.7.13-3.7-1.46 1.91-1.56 3.71-1.37 6.77s-.24 5.81-.33 6.31.3.78.3.78c.12-.66.54-3.2.74-3.68 1.67-3.93 6.3-4.86 10.33-6.66 4.51-2.02 5.36-3.9 5.36-3.9a9.37 9.37 0 0 1-2.37.92C31.74 5.99 31.41 0 31.41 0ZM23.1 7.18c-4.04 1.9-7.44 3.71-9.53 10.18l-.65 1.98s-.18-.2.11-1.73c1.26-6.6 5.72-9.02 9.87-10.86C29.66 3.74 31.12.72 31.12.72s-.4 2.52-5.61 5.32c-.8.43-1.63.78-2.42 1.15Z"
								style="stroke-width:0;fill:#a5b9f6"
							/><text
								transform="translate(0 16.78)"
								style="fill:#a5b9f6;font-family:SofiaProSoftBold,'Sofia Pro Soft';font-size:17px"
								><tspan x="0" y="0">+</tspan></text
							></svg
						>

						<a
							rel="noreferrer"
							href="/create/creative"
							class="col-span-4 block px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Post</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="25.43"
							height="22"
							viewBox="0 0 27.43 24"
							class="mx-auto cursor-pointer outline-none"
							role="menuitem"
							tabindex="0"
						>
							<path
								d="m7.99 1.76-.56 1.67h-4C1.54 3.43 0 4.97 0 6.86v13.71C0 22.46 1.54 24 3.43 24H24c1.89 0 3.43-1.54 3.43-3.43V6.86c0-1.89-1.54-3.43-3.43-3.43h-4l-.56-1.67A2.57 2.57 0 0 0 17 0h-6.58C9.31 0 8.33.71 7.98 1.76Zm5.72 6.81c2.84 0 5.14 2.3 5.14 5.14s-2.3 5.14-5.14 5.14-5.14-2.3-5.14-5.14 2.3-5.14 5.14-5.14Z"
								style="fill:#a5b9f6;stroke-width:0"
							/>
						</svg>

						<a
							rel="noreferrer"
							href="/communityposts"
							class="col-span-4 block px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Bloom Feed</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							x="0"
							y="0"
							width="30"
							height="30"
							viewBox="0 0 35 35"
							style="enable-background:new 0 0 35 35"
							xml:space="preserve"
							><style>
								.st0 {
									fill: #a5b9f6;
								}
							</style><path
								class="st0"
								d="M16.9 7.1c0 .3.2.5.4.6h.3c.4 0 .7-.3.7-.6l-.1-4.2c0-.3-.3-.6-.7-.6-.4 0-.7.3-.7.6l.1 4.2zM5.3 9.5l3.4 2.7c.1.1.1.1.2.1.3.1.6 0 .7-.2.3-.3.2-.6-.1-.9L6.3 8.6c-.3-.2-.7-.2-1 0-.3.3-.2.7 0 .9zM26 12.3c.1.1.1.1.2.1.2.1.5.1.8-.1l3.5-2.9c.3-.2.3-.6 0-.9s-.7-.3-1 0L26 11.4c-.3.2-.3.6 0 .9zM23.6 20.8c0-3.9-2-7.5-5.5-10.2-.3-.2-.6-.2-.9 0-3.6 2.7-5.5 6.3-5.5 10.2s2 7.5 5.5 10.2c.1.1.3.1.5.1s.3-.1.5-.1c3.4-2.8 5.4-6.4 5.4-10.2z"
								style="fill:#a5b9f6"
							/><path
								class="st0"
								d="M4.8 18.5s-.1 0 0 0c-.4 0-.7.3-.7.6 0 3.2 1.4 6.2 4 8.5 1.9 1.7 4.4 2.9 7 3.3-3.1-2.8-4.8-6.4-4.8-10.1 0-.4 0-.8.1-1.2-1.8-.7-3.7-1.1-5.6-1.1zM20.1 30.9c2.7-.4 5.1-1.6 7-3.3 2.6-2.3 4-5.3 3.9-8.5 0-.3-.3-.6-.7-.6-1.9 0-3.8.4-5.5 1 0 .4.1.8.1 1.2.1 3.8-1.7 7.4-4.8 10.2z"
								style="fill:#a5b9f6"
							/></svg
						>

						<div
							on:click={handleRoute}
							on:keyup={handleRoute}
							role="button"
							tabindex="0"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm cursor-pointer"
						>
							My Local Bloom
						</div>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg">
						<svg
							class="mx-auto lg:scale-75 2xl:scale-100"
							xmlns="http://www.w3.org/2000/svg"
							width="25"
							height="25"
							viewBox="0 0 30 30"
							style="enable-background:new 0 0 33 33"
							xml:space="preserve"
							><path
								d="M24.4 30.8v-8.3c0-.8.5-1.3 1-1.2.5.1 1.1 1.4 2.8 1.3 1.7-.1 2.5-1.7 2.5-2.9s-.9-2.8-2.5-2.9c-1.7-.1-2.3 1.1-2.8 1.3-.6.1-1-.4-1-1.2V8.6h-8.3c-.8 0-1.3-.5-1.2-1 .1-.5 1.4-1.1 1.3-2.8s-1.7-2.5-2.9-2.5-2.8.9-2.9 2.5c-.1 1.7 1.1 2.3 1.3 2.8.1.6-.4 1-1.2 1H2.2v8.3c0 .8.5 1.3 1 1.2.5-.1 1.1-1.4 2.8-1.3s2.5 1.7 2.5 2.9-.9 2.8-2.5 2.9-2.3-1.1-2.8-1.3c-.6-.1-1 .4-1 1.2v8.3h22.2z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/flo/offers"
							class="col-span-4 block px-4 py-2 hover:bg-cosmicPurplebg text-sm">FLO Exchange</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 58.73 36.67"
							width="29"
							height="20"
							class="mx-auto pt-1"
						>
							<path
								d="M3.63 36.55h.02c3.19-.98 6.35-2.1 9.43-3.37s6.09-2.7 9.01-4.28c5.55-3.03 10.79-6.66 15.25-11.05-5.3 8.22-18.98 16.53-18.98 16.53 8.75 2.97 16.34 3.44 23.01-2.8 6.38-5.97 9.06-13.08 12.08-21.4 2.08-5.73 5.28-9.15 5.28-9.15-7.28-.84-22.56-3.19-32.96 4.16-10.85 7.67-11.65 21.52-11.7 23.23-.79.23-1.58.45-2.37.67a99.47 99.47 0 0 1-9.34 2c-.11.02-.24.05-.36.08a2.81 2.81 0 0 0-1.87 3.5 2.81 2.81 0 0 0 3.5 1.87Z"
								style="fill:#a5b9f6;stroke-width:0"
							/>
						</svg>

						<a
							rel="noreferrer"
							href="/member/localactionrewards"
							class="col-span-4 block px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Local Action Rewards</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							xmlns="http://www.w3.org/2000/svg"
							width="23"
							height="23"
							viewBox="0 0 30 30"
							style="enable-background:new 0 0 33 33"
							xml:space="preserve"
							><path
								d="M24.4 30.8v-8.3c0-.8.5-1.3 1-1.2.5.1 1.1 1.4 2.8 1.3 1.7-.1 2.5-1.7 2.5-2.9s-.9-2.8-2.5-2.9c-1.7-.1-2.3 1.1-2.8 1.3-.6.1-1-.4-1-1.2V8.6h-8.3c-.8 0-1.3-.5-1.2-1 .1-.5 1.4-1.1 1.3-2.8s-1.7-2.5-2.9-2.5-2.8.9-2.9 2.5c-.1 1.7 1.1 2.3 1.3 2.8.1.6-.4 1-1.2 1H2.2v8.3c0 .8.5 1.3 1 1.2.5-.1 1.1-1.4 2.8-1.3s2.5 1.7 2.5 2.9-.9 2.8-2.5 2.9-2.3-1.1-2.8-1.3c-.6-.1-1 .4-1 1.2v8.3h22.2z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/viewSkills/"
							class="block col-span-4 px-4 py-2 text-sm">Bloomers</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto transform -scale-x-100"
							width="20"
							height="25"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 25 25"
							style="enable-background:new 0 0 25 25"
							xml:space="preserve"
							><path style="fill:none" d="M0 0h25v25H0z" /><path
								d="M12.5 1.6C5.6 1.6 0 6.1 0 11.7c0 2.4 1 4.7 2.8 6.4-.5 1.7-1.5 3.3-2.7 4.7-.1.1-.2.3-.1.4.1.1.2.2.4.2 2.5-.1 4.9-.9 6.9-2.5 1.7.6 3.5 1 5.2 1 6.9 0 12.5-4.6 12.5-10.2S19.4 1.6 12.5 1.6z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/chat"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Chat</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="26"
							height="26"
							viewBox="0 0 40 38"
							><defs
								><style>
									.f {
										fill: #a5b9f6;
										stroke-width: 0;
									}
								</style></defs
							><g id="c"
								><g id="d"
									><g id="e"
										><path
											class="f"
											d="M10.71 22.72h16.57c.13 0 .24.11.24.24v9.7c0 2.09-1.7 3.79-3.79 3.79h-9.47c-2.09 0-3.79-1.7-3.79-3.79v-9.7c0-.13.11-.24.24-.24ZM18.99 0C1.22 0-4.53 20.83 3.66 20.83h30.68C42.5 20.83 36.82 0 19 0ZM7.63 17.51c-1.57 0-2.84-1.27-2.84-2.84s1.27-2.84 2.84-2.84 2.84 1.27 2.84 2.84c0 1.57-1.27 2.84-2.84 2.84Zm13.25.47a7.571 7.571 0 0 1 0-15.14 7.571 7.571 0 0 1 0 15.14Z"
										/></g
									></g
								></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/learn/templates"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Resources to Grow Your Bloom</a
						>
					</li>
					<!-- <li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="scale-50 mx-auto"
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="37.5"
							height="29.82"
							viewBox="0 0 50 39.76"
							><defs
								><style>
									.d {
										fill: #a5b9f6;
										fill-rule: evenodd;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M3.12 0h39.76C44.66 0 46 1.34 46 3.12v.59H5.34C4.6 3.71 4 4.3 4 5.05s.59 1.34 1.34 1.34h40.65v4.45c0 1.63-1.34 3.12-3.12 3.12h-5.19c-1.78 0-3.12 1.34-3.12 2.97v5.93c0 1.63 1.34 2.97 3.12 2.97h5.19c1.78 0 3.12 1.48 3.12 3.12v7.72c0 1.78-1.34 3.12-3.12 3.12H3.12C1.34 39.79 0 38.45 0 36.67V3.12C0 1.34 1.34 0 3.12 0Z"
								/><path
									class="d"
									d="M38.13 14.54h9.2c1.48 0 2.67 1.19 2.67 2.67v5.34c0 1.48-1.19 2.67-2.67 2.67h-9.2c-1.48 0-2.67-1.19-2.67-2.67v-5.34c0-1.48 1.19-2.67 2.67-2.67Zm1.93 3.41c1.04 0 1.78.89 1.78 1.93s-.74 1.78-1.78 1.78-1.93-.74-1.93-1.78.89-1.93 1.93-1.93Z"
								/></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/wallet"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Wallet</a
						>
					</li> -->
					<!-- <li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							xmlns="http://www.w3.org/2000/svg"
							height="30"
							width="30"
							viewBox="0 0 30 30"
							style="enable-background:new 0 0 30 30"
							xml:space="preserve"
							><path
								d="M4.9 23.6v-1c0-1-.1-2.1.1-3.2.6-5.1 4.9-9 10.1-9 5.2 0 9.5 3.9 10 8.9.2 1.1.1 2.2.1 3.3v1h3.2l.2-.1.2-.1.1-.1.1-.2.1-.1v-.2c.1-.7.2-1.4.2-2.2 0-7.8-6.3-14.2-14.2-14.2S.8 12.7.8 20.6c0 .7.1 1.5.2 2.2.1.5.5.9 1 .9l2.9-.1zm2 0h2.9c.3 0 .6-.2.8-.4.2-.3.2-.6.2-.9-.1-.4 0-1.2 0-1.6 0-2.3 1.9-4.2 4.2-4.2 2.3 0 4.2 1.9 4.2 4.2 0 .5.2 2 .2 2 .1.5.5.9 1 .9h2.9v-1.1c.1-.9.1-1.9 0-2.8v-.1c-.5-4-3.9-7.2-8-7.2-4.2 0-7.6 3.2-8 7.2-.1 1-.1 1.9 0 2.9l-.4 1.1z"
								style="fill-rule:evenodd;clip-rule:evenodd;fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/member/blogs"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Members-Only Blog</a
						>
					</li> -->
					<!-- <li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							width="23"
							height="27"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							style="enable-background:new 0 0 512 512"
							xml:space="preserve"
							><path
								d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/profile"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Profile</a
						>
					</li> -->
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="25"
							height="20"
							viewBox="0 0 70.14 56.95"
							class="mx-auto lg:scale-75"
							><defs
								><style>
									.d {
										fill: #a5b9f6;
										stroke-width: 0;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M64.2 29.81c-2.31 0-4.49-.83-6.13-2.33-.64-.58-1.67-.58-2.3 0-1.64 1.5-3.82 2.33-6.13 2.33s-4.49-.83-6.13-2.33c-.63-.58-1.67-.58-2.3 0-1.64 1.5-3.82 2.33-6.13 2.33s-4.49-.83-6.13-2.33c-.63-.58-1.67-.58-2.3 0-1.65 1.5-3.82 2.33-6.13 2.33s-4.49-.83-6.13-2.33c-.64-.58-1.67-.58-2.3 0-1.64 1.5-3.82 2.33-6.13 2.33-.76 0-1.52-.1-2.27-.27v24.13c0 1.81 1.48 3.29 3.29 3.29h37.88V34.81h9.6v22.15h8.47c1.85 0 3.36-1.51 3.36-3.36V29.59c-.68.15-1.38.23-2.07.23ZM28.99 44.98H14.5V34.81h14.49v10.17ZM10.11 25.33c1.75-1.6 4.48-1.6 6.23 0 1.11 1.01 2.59 1.57 4.17 1.57s3.06-.56 4.17-1.57c1.75-1.59 4.48-1.6 6.23 0 1.11 1.01 2.59 1.57 4.17 1.57s3.06-.56 4.17-1.57c1.75-1.6 4.48-1.6 6.23 0 1.11 1.01 2.59 1.57 4.17 1.57s3.06-.56 4.17-1.57c.87-.8 1.99-1.2 3.11-1.2s2.24.4 3.11 1.2c1.11 1.01 2.59 1.57 4.17 1.57 2.02 0 4.13-.95 5.23-2.36.63-.81.85-1.64.64-2.49-1.04-4.24-7.07-13.83-10.31-18.99-.55-.88-1.03-1.63-1.4-2.24A1.72 1.72 0 0 0 56.9 0H13.06c-.6 0-1.16.32-1.47.83-.37.62-.85 1.4-1.41 2.3C7.01 8.27 1.1 17.84.08 22.04c-.21.85.01 1.69.65 2.5 1.1 1.41 3.2 2.35 5.22 2.35 1.58 0 3.06-.56 4.17-1.57Z"
								/></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/marketplace"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Marketplace</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							version="1.1"
							id="Layer_1"
							xmlns="http://www.w3.org/2000/svg"
							x="0"
							y="0"
							width="26"
							height="26"
							viewBox="0 0 12.3 23.3"
							style="enable-background:new 0 0 12.3 23.3"
							xml:space="preserve"
							><style>
								.st0 {
									fill: #a5b9f6;
								}
							</style><path
								class="st0"
								d="M6 18.7c-1.1 0-1.9-.7-1.9-1.8S5 15 6 15c1 0 1.8.8 1.8 1.8 0 1.1-.7 1.9-1.8 1.9zM0 5.1C0 1.9 3.4 0 6.3 0c3 0 6 1.7 6 4.9 0 3.8-4.2 4-5 7.7-.3 1.9-3 1.8-3-.4 0-4.1 4.6-4.8 4.6-7.2 0-1.5-1.2-2.3-2.6-2.3-1.9 0-2.5 1.1-3.1 2.7C2.5 7.6 0 6.7 0 5.1z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="/learn/faq"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>FAQ</a
						>
					</li>
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto pl-[3px] pt-[1px]"
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="21.81"
							height="23.15"
							><defs
								><style>
									.d {
										fill: #a5b9f6;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M15.82 14.04h1.08c.28 0 .51-.22.51-.48v-1.61c0-.27-.23-.48-.51-.48h-1.08a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 10.84h1.48c.28 0 .51-.22.51-.48V8.75c0-.27-.23-.48-.51-.48h-1.48a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 7.65h1.08c.28 0 .51-.22.51-.48V5.56c0-.27-.23-.48-.51-.48h-1.08a.38.38 0 0 0-.39.37v1.83c0 .2.18.37.39.37ZM15.82 1.88h1.48c.28 0 .51.22.51.48v1.61c0 .27-.23.48-.51.48h-1.48a.38.38 0 0 1-.39-.37V2.25c0-.2.18-.37.39-.37ZM2.21 14.72C1 14.72 0 15.72 0 16.93s1 2.22 2.21 2.22h11.81c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6H2.21c-.57 0-1.01-.45-1.01-1.02s.45-1.01 1.01-1.01c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6Z"
								/><path
									class="d"
									d="M13.14 14.72c-.33 0-.6.27-.6.6v3.23c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-3.23c0-.33-.27-.6-.6-.6Z"
								/><path
									class="d"
									d="M2.21 0C1 0 0 1 0 2.21v14.72h1.19a1 1 0 0 1 1.01-1.01h10.33c1.14 0 2.08-.94 2.08-2.08V2.07C14.62.93 13.68 0 12.54 0H2.21Z"
								/></g
							></svg
						>
						<a
							rel="noreferrer"
							href="/learn/wiki"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Wiki</a
						>
					</li>
					<!-- <li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="32"
							height="26"
							viewBox="0 0 28 60"
							class="mt-5 ml-2"
							><defs
								><style>
									.d {
										fill: #a5b9f6;
										stroke-width: 0;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M11.6 5.8c0 3.2-2.6 5.8-5.8 5.8S0 9 0 5.8 2.6 0 5.8 0s5.8 2.6 5.8 5.8ZM31.1 5.8c0 3.2-2.6 5.8-5.8 5.8S19.5 9 19.5 5.8 22.1 0 25.3 0s5.8 2.6 5.8 5.8Z"
								/><circle class="d" cx="44.8" cy="5.8" r="5.8" /></g
							></svg
						>
						<button
							class="block col-span-4 px-4 py-2 border-none hover:bg-cosmicPurplebg text-sm text-left"
							on:click={toggleMore}>More</button
						>
					</li>
					{#if moreToggle == true} -->
					<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							class="mx-auto"
							width="23"
							height="27"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 512 512"
							style="enable-background:new 0 0 512 512"
							xml:space="preserve"
							><path
								d="m47.6 300.4 180.7 168.7c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l180.7-168.7c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141-45.6-7.6-92 7.3-124.6 39.9l-12 12-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
								style="fill:#a5b9f6"
							/></svg
						>
						<a
							rel="noreferrer"
							href="https://docs.google.com/document/u/0/d/1eXL_CP6lnge-VOTzEDkmPKAsNd1xLBZBj2zuG4DSFKk"
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
							on:click={toggleNav}>Code of Conduct</a
						>
					</li>
					{#if $user && !$user.member}
						<li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
							<svg
								class="mx-auto"
								width="23"
								height="27"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 512 512"
								style="enable-background:new 0 0 512 512"
								xml:space="preserve"
							></svg>
							<button
								class="block col-span-4 px-4 py-2 border-none hover:bg-cosmicPurplebg text-sm text-left"
								on:click={onSignout}
							>
								Log Out
							</button>
						</li>
					{/if}
					<!-- <li class="grid grid-cols-5 items-center px-4 hover:bg-cosmicPurplebg text-sm">
						<svg
							id="b"
							xmlns="http://www.w3.org/2000/svg"
							width="19.58"
							height="20"
							role="button"
							aria-pressed="false"
							tabindex="0"
							class="mx-auto"
							on:click={onSignout}
							on:keyup|preventDefault={(el) => {
								if (el.key === 'Enter') onSignout();
							}}
							><defs
								><style>
									.d {
										fill: #a5b9f6;
										stroke-width: 0;
									}
								</style></defs
							><g id="c"
								><path
									class="d"
									d="M10.5 12.96c-1.08 0-1.96-.88-1.96-1.96s.89-1.96 1.96-1.96h3.96V2.79C14.46 1.25 13.2 0 11.67 0H2.79C1.25 0 0 1.25 0 2.79v16.42C0 20.75 1.25 22 2.79 22h8.88c1.53 0 2.79-1.25 2.79-2.79v-6.25H10.5Z"
								/><path
									class="d"
									d="m21.34 10.44-3.51-3.43c-.31-.3-.81-.3-1.11.01-.3.31-.3.81.01 1.11l2.13 2.08H10.5c-.43 0-.79.35-.79.79s.35.79.79.79h8.36l-2.13 2.08c-.31.3-.32.8-.01 1.11.15.16.36.24.56.24s.4-.07.55-.22l3.51-3.43c.07-.07.13-.16.17-.25a.815.815 0 0 0 0-.62c-.04-.1-.1-.18-.17-.25Z"
								/></g
							></svg
						>
						<div
							role="button"
							aria-pressed="false"
							tabindex="0"
							on:click={onSignout}
							on:keyup|preventDefault={(el) => {
								if (el.key === 'Enter') onSignout();
							}}
							class="block col-span-4 px-4 py-2 hover:bg-cosmicPurplebg text-sm"
						>
							Sign Out
						</div>
					</li> -->
					<!-- {/if} -->

					<!-- Add more navigation items as needed -->
				{/if}
			</ul>
		</div>
	</div>
{/if}

<!-- Mobile/tablet profile icon -->
<div class="xl:hidden absolute right-1 flex flex-col">
	{#if $user && $profileStore}
		<div class="flex items-center">
			{#if $user.member}
				{#if $profileLoading}
					<!-- Loading state for profile -->
					<div class="flex items-center border-none ml-2">
						<div class="animate-spin rounded-full h-6 w-6 border-b-2 border-cosmicCyan mr-2"></div>
						<p class="text-cosmicPurple100 text-sm">Loading...</p>
					</div>
				{:else if $profileStore.username}
					<button
						on:click={toggleProfile}
						on:keyup|preventDefault={(el) => {
							if (el.key === 'Enter') toggleProfile();
						}}
						class="flex items-center border-none ml-2"
					>
						<img
							class="w-10 h-10 ring-2 object-cover ring-cosmicPurple600 rounded-full scale-105"
							src={avatarUrl}
							alt={'avatar photo'}
						/>
					</button>
					<!-- Profile Dropdown Menu -->
					<div id="dropdownMenu" class="relative">
						{#if profileToggle}
							<ul
								class="dropdown-menu absolute top-full -mt-1 w-36 -right-8 bg-cosmicPurplebg border-none rounded-xl shadow-lg space-y-3 text-cosmicPurple100 pl-6 pt-4 pb-1 text-sm font-bold"
							>
								<li>
									<a class="text-cosmicPurple100" rel="no-refferer" href="/profile">Profile</a>
								</li>
								<li>
									<a
										class="text-cosmicPurple100"
										rel="no-refferer"
										href="/member/{$profileStore.username}">My Posts</a
									>
								</li>
								<li>
									<a class="text-cosmicPurple100" rel="no-refferer" href="/wallet">My Wallet</a>
								</li>
								<li>
									<button class="text-cosmicPurple100 border-none -ml-4 -mt-4" on:click={onSignout}
										>Log Out</button
									>
								</li>
							</ul>
						{/if}
					</div>
				{:else}
					<a href="/profile" class="norefferer mr-2">
						<button
							class="bg-bloomBlueNormal rounded-lg py-2 px-3 border border-bloomBlueDarker font-exo-2 font-black text-center text-xs xs:text-sm text-black"
						>
							Complete Your Profile
						</button>
					</a>
				{/if}
			{:else}
				<a href="/join" class="norefferer mr-2">
					<button
						class="bg-bloomBlueNormal rounded-lg py-2 px-3 border border-bloomBlueDarker font-exo-2 font-black text-center text-xs xs:text-sm text-black"
					>
						Finish Applying
					</button>
				</a>
			{/if}

			<a
				rel="no-refferer"
				href={'/member/notifications'}
				data-sveltekit-preload-data="hover"
				on:click={() => {
					if ($user.member) toggleProfile();
				}}
			>
				<!-- on:click={handlePopup} -->
				<img src="/img/daisy3.png" alt="daisy" class="w-10 -ml-1 scale-75" />
				<span
					class="inline-block absolute top-0 text-white right-0 rounded-full text-center text-base min-w-6 h-6 line-height-6 px-2"
				>
					<!-- show number of messages -->
					{#if $unreadCount > 0}
						<span class="badge">{$unreadCount}</span>
					{/if}
				</span>
			</a>
		</div>
	{:else if $user}
		<div
			role="button"
			aria-pressed="false"
			tabindex="0"
			on:click={onSignout}
			on:keyup|preventDefault={(el) => {
				if (el.key === 'Enter') onSignout();
			}}
			class="block col-span-4 px-3 py-2 hover:bg-cosmicPurplebg text-sm"
		>
			Sign Out
		</div>
	{:else}
		<div class="flex gap-1">
			<button
				class="bg-gradientBlue rounded-lg py-3 top-4 right-8 border border-bloomBlueDarker font-exo-2 font-black text-center text-xs xs:text-sm text-black"
				on:click={() => paraLogin()}
			>
				Login
			</button>
			<a class="norefferer" href="/join">
				<button
					class="bg-bloomBlueNormal rounded-lg py-3 top-4 right-8 border border-bloomBlueDarker font-exo-2 font-black text-center text-xs xs:text-sm text-black"
				>
					Apply
				</button></a
			>
		</div>
	{/if}
</div>

<!-- {#if !$user}
	{#if profileToggle == true}
		<div
			class="-mt-1 px-2 pt-2 pb-3 space-y-1 bg-bloomPurpleNormal top-[72px] absolute w-full lg:right-20 lg:translate-x-6 xl:right-32 xl:translate-x-6 lg:w-52 lg:-mt-4 border border-bloomPurpleDarker font-exo-2 font-black"
		>
			<a
				href={'/auth'}
				data-sveltekit-preload-data="hover"
				on:click={toggleProfile}
				class="{navMenuClass} text-center">Login/Join</a
			>
		</div>
	{/if}
{/if} -->

<style>
	a {
		color: #a5b9f6;
	}

	.navbar-menu {
		display: none;
	}

	.navbar-menu.open {
		display: block;
	}

	/* unread message count */
	.badge {
		display: inline-block;
		position: absolute;
		top: 0;
		/* background-color: #4285f4; */
		background-color: #ff00ff;
		color: #d7e6fd;
		right: 0;
		border-radius: 9999px;
		border: none;
		font-size: 14px;
		min-width: 20px;
		line-height: 20px;
		min-height: 20px;
		text-align: center;
	}
	/* custom width for message popup */
	.messages {
		min-width: 400px;
	}
</style>
